import { trpc } from './trpc'
import { useToast } from '@/components/ui/use-toast'

export function useApplePayDomainsList(opts?: { enabled?: boolean }) {
    return trpc.admin.applePayDomainsList.useQuery(undefined, {
        staleTime: 60 * 1000,
        enabled: opts?.enabled ?? true,
    })
}

export function useApplePayRegisterDomain() {
    const { toast } = useToast()
    const utils = trpc.useUtils()
    return trpc.admin.applePayRegisterDomain.useMutation({
        onSuccess: () => {
            utils.admin.applePayDomainsList.invalidate()
            toast({ title: 'Success', description: 'Domain registered with provider and set verified on integrations' })
        },
        onError: (error: { message: string }) => {
            toast({ title: 'Error', description: error.message, variant: 'destructive' })
        },
    })
}

export function useApplePayRegisterCustomDomain() {
    const { toast } = useToast()
    const utils = trpc.useUtils()
    return trpc.admin.applePayRegisterCustomDomain.useMutation({
        onSuccess: () => {
            utils.admin.applePayDomainsList.invalidate()
            toast({ title: 'Domain registered', description: 'Successfully registered with Basis Theory' })
        },
        onError: (error: { message: string }) => {
            toast({ title: 'Registration failed', description: error.message, variant: 'destructive' })
        },
    })
}

export function useApplePayDeregisterDomain() {
    const { toast } = useToast()
    const utils = trpc.useUtils()
    return trpc.admin.applePayDeregisterDomain.useMutation({
        onSuccess: () => {
            utils.admin.applePayDomainsList.invalidate()
            toast({ title: 'Success', description: 'Domain deregistered and set unverified on integrations' })
        },
        onError: (error: { message: string }) => {
            toast({ title: 'Error', description: error.message, variant: 'destructive' })
        },
    })
}
